import { render, staticRenderFns } from "./giftCode.vue?vue&type=template&id=682b6330&scoped=true&"
import script from "./giftCode.vue?vue&type=script&lang=js&"
export * from "./giftCode.vue?vue&type=script&lang=js&"
import style0 from "./giftCode.vue?vue&type=style&index=0&id=682b6330&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682b6330",
  null
  
)

export default component.exports